"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateService = void 0;
var _1 = require("./");
var dayjs = require("dayjs");
var localizedFormat = require("dayjs/plugin/localizedFormat");
var localeData = require("dayjs/plugin/localeData");
var bgLocale = require("dayjs/locale/bg");
var csLocale = require("dayjs/locale/cs");
var daLocale = require("dayjs/locale/da");
var deATLocale = require("dayjs/locale/de-at");
var deCHLocale = require("dayjs/locale/de-ch");
var deLocale = require("dayjs/locale/de");
var enAULocale = require("dayjs/locale/en-au");
var enCALocale = require("dayjs/locale/en-ca");
var enGBLocale = require("dayjs/locale/en-gb");
var enINLocale = require("dayjs/locale/en-in");
var enSGLocale = require("dayjs/locale/en-SG");
var esLocale = require("dayjs/locale/es");
var etLocale = require("dayjs/locale/et");
var fiLocale = require("dayjs/locale/fi");
var frLocale = require("dayjs/locale/fr");
var frCHLocale = require("dayjs/locale/fr-ch");
var hrLocale = require("dayjs/locale/hr");
var huLocale = require("dayjs/locale/hu");
var isLocale = require("dayjs/locale/is");
var itLocale = require("dayjs/locale/it");
var koLocale = require("dayjs/locale/ko");
var ltLocale = require("dayjs/locale/lt");
var lvLocale = require("dayjs/locale/lv");
var nbLocale = require("dayjs/locale/nb");
var nlBELocale = require("dayjs/locale/nl-be");
var nlLocale = require("dayjs/locale/nl");
var plLocale = require("dayjs/locale/pl");
var ptLocale = require("dayjs/locale/pt");
var roLocale = require("dayjs/locale/ro");
var ruLocale = require("dayjs/locale/ru");
var skLocale = require("dayjs/locale/sk");
var slLocale = require("dayjs/locale/sl");
var srLocale = require("dayjs/locale/sr");
var svLocale = require("dayjs/locale/sv");
var trLocale = require("dayjs/locale/tr");
var ukLocale = require("dayjs/locale/uk");
var zhCNLocale = require("dayjs/locale/zh-cn");
var zhTWLocale = require("dayjs/locale/zh-tw");
var localesMapping = {
    bg: bgLocale,
    cs: csLocale,
    da: daLocale,
    'de-at': deATLocale,
    'de-ch': deCHLocale,
    de: deLocale,
    'en-au': enAULocale,
    'en-ca': enCALocale,
    'en-gb': enGBLocale,
    'en-in': enINLocale,
    'en-sg': enSGLocale,
    es: esLocale,
    et: etLocale,
    fi: fiLocale,
    fr: frLocale,
    'fr-ch': frCHLocale,
    hr: hrLocale,
    hu: huLocale,
    is: isLocale,
    it: itLocale,
    ko: koLocale,
    lt: ltLocale,
    lv: lvLocale,
    nb: nbLocale,
    'nl-be': nlBELocale,
    nl: nlLocale,
    pl: plLocale,
    pt: ptLocale,
    ro: roLocale,
    ru: ruLocale,
    sk: skLocale,
    sl: slLocale,
    sr: srLocale,
    sv: svLocale,
    tr: trLocale,
    uk: ukLocale,
    'zh-cn': zhCNLocale,
    'zh-tw': zhTWLocale,
};
dayjs.extend(localizedFormat);
dayjs.extend(localeData);
var DateService = /** @class */ (function () {
    function DateService() {
    }
    DateService.getTimestamp = function () {
        return Date.now();
    };
    DateService.setLocale = function (locale) {
        var localeLowerCase = locale.toLowerCase();
        var language = _1.UtilService.parseLanguageCode(localeLowerCase);
        var dayjsLocale = localesMapping[localeLowerCase] || localesMapping[language];
        dayjs.locale(dayjsLocale);
    };
    DateService.getWeekdays = function () {
        return dayjs().localeData().weekdays();
    };
    DateService.formatDate = function (date, formatPattern) {
        if (formatPattern === void 0) { formatPattern = 'dddd, LL'; }
        return dayjs(date).format(formatPattern);
    };
    DateService.getTodayISOString = function () {
        var date = new Date();
        date.setUTCHours(0, 0, 0, 0);
        return date.toISOString();
    };
    return DateService;
}());
exports.DateService = DateService;
